import { Injectable } from '@angular/core';
import { Collection, CollectionProducts } from '../models/collection.schema';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class CollectionService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/shop-collection`;
  async getCollection(id: number): Promise<Collection> {
    return this.request(() => this.http.get<Collection>(`${this.url}/${id}`).toPromise());
  }

  async getAllShopCollections(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }

  async createOrUpdateCollection(collection: any){
    return this.request(() =>
      this.http.post(`${this.url}`, collection).toPromise()
    );
  }

  async updateCollection(collectionId: number, collection: any){
    return this.request(() =>
      this.http.put(`${this.url}/${collectionId}`, collection).toPromise()
    );
  }

  async deleteCollection(id: number): Promise<{ id: number, success: boolean }> {
    return this.request(() => this.http.delete<{ id: number, success: boolean }>(`${this.url}/${id}`).toPromise());
  }
}
